<template>
  <div class="video-fallback" :style="{ width, height, borderRadius }">
    <VIcon v-if="showIcon" name="video-off-line" class="video-fallback__icon"></VIcon>
    <div class="video-fallback__body">
      <div class="video-fallback__title-row">
        <p class="video-fallback__text">This video format cannot be previewed in the browser.</p>
        <HelpTooltip
          class="video-fallback__tooltip"
          :iconStyle="{ color: 'var(--white)' }"
        >
          Modern browsers (Chrome, Firefox, Edge, Safari) have dropped native support for MPEG/MPG video. Unlike MP4 (H.264), which is royalty-free for web use, MPEG requires proprietary codecs that browsers no longer ship. This is a browser-level limitation — not something the platform can override.
        </HelpTooltip>
      </div>
      <a :href="url" target="_blank" rel="noopener noreferrer" class="video-fallback__link">Download to view</a>
    </div>
  </div>
</template>

<script>
import HelpTooltip from '@/components/HelpTooltip.vue';

export default {
  name: 'VideoFallback',
  components: { HelpTooltip },
  props: {
    /** The download URL for the video file. */
    url: {
      type: String,
      required: true
    },
    /** Override the component width, e.g. '200px' for carousel cards. */
    width: {
      type: String,
      default: '240px'
    },
    /** Override the component height, e.g. '100%' to fill a carousel image block. */
    height: {
      type: String,
      default: 'auto'
    },
    borderRadius: {
      type: String,
      default: '10px'
    },
    /** Whether to show the videocam-off icon. */
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
  }
};
</script>

<style scoped>
/* ── Base layout ── */
.video-fallback {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-radius: 10px;
  max-width: 100%;
  box-sizing: border-box;
  background: var(--gray-04);
}

.video-fallback__icon {
  font-size: 36px;
  flex-shrink: 0;
  color: var(--white);
}

.video-fallback__text {
  font-size: 13px;
  font-weight: 400;
  margin: 0 0 4px 0;
  line-height: 1.4;
  color: var(--white);
}

.video-fallback__link {
  font-size: 13px;
  text-decoration: underline;
  color: var(--white) !important;
}

.video-fallback__title-row {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
</style>
